import React, {useEffect} from 'react'
import './Toasts.css'

function Toasts(props) {
  const {stateToasts, setStateToasts} = props

  useEffect(() => {
    setTimeout(
      () => {
        hideToasts()
      },
      props.timer ? props.timer : 4000,
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateToasts])

  function hideToasts() {
    setStateToasts(false)
  }

  return (
    <div
      style={props.color && {backgroundColor: `${props.color}`}}
      className={`content-toasts content-responsive z-index-99 ${stateToasts ? 'show' : 'hide'}`}>
      <h3 className="txt-5--bold m-0">{props.text}</h3>
      <i className={props.icon}></i>
    </div>
  )
}

export default Toasts
